exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-list-item[data-v-b201d732] {\n  background-color: #f8f8f8;\n  max-width: 600px;\n  margin: 0 auto;\n}\n.product__catalog_items .product-list-item[data-v-b201d732] {\n  background-color: inherit;\n}\n.page-title[data-v-b201d732] {\n  color: #153050;\n  font-family: 'Wittaya-Medium';\n  font-size: 2rem;\n  margin-bottom: 15px;\n}\n.page-title--campaign[data-v-b201d732] {\n    font-family: 'Wittaya-Light';\n    font-weight: 300;\n    font-size: 1.25rem;\n    margin: 0;\n}\n.campaign-title[data-v-b201d732] {\n  font-size: 1.5rem;\n}\n@media only screen and (min-width: 768px) {\n.campaign-title[data-v-b201d732] {\n      font-size: 2rem;\n}\n}\nh3[data-v-b201d732] {\n  word-break: break-word;\n  word-wrap: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b201d732","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductDetail.vue
// module id = 597
// module chunks = 1